import axios, { AxiosInstance } from "axios";

const portalApiClient: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_PORTAL_API_ENDPOINT,
    headers:{'Access-Control-Allow-Origin': '*'}
});

portalApiClient.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params['culture'] = document.documentElement.getAttribute('lang');
    return config;
});

portalApiClient.interceptors.response.use(
    (response) => { return response; },
    (error) => {
        switch (error.response.status) {
            case 401:
            case 403:
                // router.push({ name: "NotFound" })
                break;
            case 500:
                // router.push({ name: "FiveHundredError" })
                break;
        }
        return Promise.reject(error);
    }
);

export default portalApiClient;